export class UserSettingsChanger {

	constructor(public propertyName: string) {
	}

	public changeSettingTo(value: string | number | boolean): JQueryXHR {
		return $.post("/timr/changeUserSetting.json?propertyName=" + this.propertyName + "&value=" + value);
	}

}
